import { GetVenueCategoriesResponseTypeDataItem } from 'src/api/generated/touring/types';
import { VenueCategoryUnionType } from './types';

export const mapVenueCategoryType = (
  apiCategory: GetVenueCategoriesResponseTypeDataItem
): VenueCategoryUnionType => {
  return apiCategory;
};
